"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _SanitizeConfiguration = require("./SanitizeConfiguration");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _Autolinker = _interopRequireDefault(require("./Autolinker"));

var _Sanitize = require("./Sanitize");

var _fixImages = require("../transformers/fixImages");

var _removeOutlookLineBreaks = require("../transformers/removeOutlookLineBreaks");

var _removeReply = require("../transformers/removeReply");

var _replaceGmailDivs = require("../transformers/replaceGmailDivs");

var _removeGmailLineBreakBeforeReply = require("../transformers/removeGmailLineBreakBeforeReply");

var _removeEmailSignature = require("../transformers/removeEmailSignature");

var hasReplyOrSignature = (0, _memoize.default)(function (body) {
  return !![].concat((0, _toConsumableArray2.default)(_removeReply.REPLY_CLASSLIST), [_removeReply.OFFICE_365_REPLY_ID], (0, _toConsumableArray2.default)(_removeEmailSignature.SIGNATURE_CLASSLIST), [_removeEmailSignature.GMAIL_SIGNATURE]).find(function (replyIdentifier) {
    return body.includes(replyIdentifier);
  });
});
var getTextContentFromHtml = (0, _memoize.default)(function (text) {
  return (0, _Sanitize.sanitize)(text, _SanitizeConfiguration.config.TEXTONLY);
});
var formatThreadedEmailPreview = (0, _memoize.default)(function (text) {
  var charLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  var transformers = [_removeOutlookLineBreaks.removeOutlookLineBreaks, _replaceGmailDivs.replaceGmailDivs, _removeReply.removeReply];
  var formattedText = (0, _Sanitize.sanitize)(text, _SanitizeConfiguration.config.TEXTONLY, transformers);
  return formattedText && formattedText.length > charLimit ? formattedText.substring(0, charLimit) : formattedText;
});
var cleanHtmlWithoutEmailReplies = (0, _memoize.default)(function (text) {
  var shouldRemoveGmailLineBreakBeforeReply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var shouldRemoveEmailSignature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var optionalTransformers = [].concat((0, _toConsumableArray2.default)(shouldRemoveGmailLineBreakBeforeReply ? [_removeGmailLineBreakBeforeReply.removeGmailLineBreakBeforeReply] : []), (0, _toConsumableArray2.default)(shouldRemoveEmailSignature ? [_removeEmailSignature.removeEmailSignature] : []));
  var transformers = [_removeOutlookLineBreaks.removeOutlookLineBreaks, _replaceGmailDivs.replaceGmailDivs, _removeReply.removeReply, _fixImages.fixImages].concat((0, _toConsumableArray2.default)(optionalTransformers));
  return (0, _Sanitize.sanitize)(text, _SanitizeConfiguration.config.HTML, transformers);
});
var cleanHtmlWithEmailReplies = (0, _memoize.default)(function (text) {
  var shouldRemoveGmailLineBreakBeforeReply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var shouldRemoveEmailSignature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var optionalTransformers = [].concat((0, _toConsumableArray2.default)(shouldRemoveGmailLineBreakBeforeReply ? [_removeGmailLineBreakBeforeReply.removeGmailLineBreakBeforeReply] : []), (0, _toConsumableArray2.default)(shouldRemoveEmailSignature ? [_removeEmailSignature.removeEmailSignature] : []));
  var transformers = [_removeOutlookLineBreaks.removeOutlookLineBreaks, _replaceGmailDivs.replaceGmailDivs, _fixImages.fixImages].concat((0, _toConsumableArray2.default)(optionalTransformers));
  return (0, _Sanitize.sanitize)(text, _SanitizeConfiguration.config.HTML, transformers);
});

var escapeBrackets = function escapeBrackets(text) {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};

var formatHtml = function formatHtml(body) {
  var formattingOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var shouldAutolinkTwitter = formattingOptions.shouldAutolinkTwitter,
      shouldIncludeReplies = formattingOptions.shouldIncludeReplies,
      shouldRemoveGmailLineBreakBeforeReply = formattingOptions.shouldRemoveGmailLineBreakBeforeReply,
      shouldRemoveEmailSignature = formattingOptions.shouldRemoveEmailSignature,
      isPlainText = formattingOptions.isPlainText,
      shouldPreserveNewlines = formattingOptions.shouldPreserveNewlines;

  if (!body) {
    return '';
  }

  var bodyToFormat = isPlainText ? escapeBrackets(body) : body;
  var formattedBody = shouldIncludeReplies ? cleanHtmlWithEmailReplies(bodyToFormat, shouldRemoveGmailLineBreakBeforeReply, shouldRemoveEmailSignature) : cleanHtmlWithoutEmailReplies(bodyToFormat, shouldRemoveEmailSignature, shouldRemoveGmailLineBreakBeforeReply);
  formattedBody = isPlainText || shouldPreserveNewlines ? formattedBody : formattedBody.replace('\n', '');
  var autolinker = shouldAutolinkTwitter ? _Autolinker.default.getTwitter() : _Autolinker.default.get();
  return autolinker.link(formattedBody);
};

var HtmlSanitizer = {
  escapeBrackets: escapeBrackets,
  getTextContentFromHtml: getTextContentFromHtml,
  hasReplyOrSignature: hasReplyOrSignature,
  formatHtml: formatHtml,
  formatThreadedEmailPreview: formatThreadedEmailPreview,
  OFFICE_365_REPLY_ID: _removeReply.OFFICE_365_REPLY_ID
};
var _default = HtmlSanitizer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/sanitizers/HtmlSanitizer.js
// module id = 805
// module chunks = 209 210 211 212